import script from "./NotificationContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationContainer.vue?vue&type=script&setup=true&lang=js"

import "./NotificationContainer.vue?vue&type=style&index=0&id=49e305d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49e305d4"]])

export default __exports__